import { createContext, useContext } from "react";
import type { AmcVisit } from "features/AmcVisitLogs/types/amc-visit.types";

interface AmcVisitOverviewContextType {
  visit: AmcVisit | null;
  refetch: () => Promise<void>;
}

const AmcVisitOverviewContext =
  createContext<AmcVisitOverviewContextType | null>(null);

export const useAmcVisitOverview = () => {
  const context = useContext(AmcVisitOverviewContext);
  if (!context) {
    throw new Error("useAmcVisitOverview must be used within provider");
  }
  return context;
};

export default AmcVisitOverviewContext;
